import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { gettext } from '@eb/i18n-ebspa';
import take from 'lodash/take';
import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';

import {
    SHARE_OPTIONS_PROPTYPE,
    SEARCH_SECTION,
    LIST_CARD_TEMPLATE,
} from '../constants';

import CardBucket from './cardBucket/CardBucket';

export default class SearchNoResultsSuggestionsEvents extends PureComponent {
    static propTypes = {
        shareOptions: SHARE_OPTIONS_PROPTYPE.isRequired,
        onSaveEvent: PropTypes.func,
        userCollections: PropTypes.arrayOf(PropTypes.object),
        onAddOrRemoveEventToCollection: PropTypes.func,
        onCreateCollection: PropTypes.func,
        isAuthenticated: PropTypes.bool,
        // TODO: Add proptype shape
        eventSuggestions: PropTypes.arrayOf(PropTypes.object),
        allEventsUrl: PropTypes.string,
        trackGAEventOnPageUnload: PropTypes.func,
    };

    render() {
        const {
            eventSuggestions,
            shareOptions,
            onSaveEvent,
            isAuthenticated,
            allEventsUrl,
            featureFlags,
            userCollections,
            onAddOrRemoveEventToCollection,
            onCreateCollection,
            trackGAEventOnPageUnload,
            suggestionsLoading,
        } = this.props;

        let eventSuggestionsComponent = null;

        if (!isEmpty(eventSuggestions) || suggestionsLoading) {
            let content = map(eventSuggestions, (event = {}) => ({
                ...event,
                section: SEARCH_SECTION,
                excludeExtraContent: true,
            }));

            content = take(content, 5);

            eventSuggestionsComponent = (
                <div className="eds-l-pad-bot-4">
                    <CardBucket
                        isLoading={suggestionsLoading}
                        content={content}
                        template={LIST_CARD_TEMPLATE}
                        shareOptions={shareOptions}
                        name={gettext('Popular events')}
                        linkUrl={allEventsUrl}
                        onSaveEvent={onSaveEvent}
                        isAuthenticated={isAuthenticated}
                        featureFlags={featureFlags}
                        bucketKey="near_you"
                        userCollections={userCollections}
                        trackGAEventOnPageUnload={trackGAEventOnPageUnload}
                        onAddOrRemoveEventToCollection={
                            onAddOrRemoveEventToCollection
                        }
                        onCreateCollection={onCreateCollection}
                    />
                </div>
            );
        }

        return eventSuggestionsComponent;
    }
}
